<template>
<el-row>
  <el-col :span="24">
    <div class="grid-content bg-purple-dark">
      <el-form  :model="form" ref="form" label-width="80px" style="margin-top:20px;">
        <el-form-item label="来访者" style="float: left;" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="处理状态" style="float: left;" prop="region">
          <el-select v-model="form.region" placeholder="请选择活动区域" style="width:220px">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间段" style="width:350px;height:50px;float: left;" >
          <el-col :span="11">
          <el-date-picker prop="date1" v-model="form.date1" type="daterange" align="right"  unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
          </el-date-picker>
          </el-col>
          <el-col class="line" :span="2" style="width:20px;margin-left: 140px;">-</el-col>
        </el-form-item>
        <el-form-item style="padding-top:60px;float:right">
          <el-button type="primary" plain @click="resetForm('form')">重置条件</el-button>
          <el-button type="primary" @click="onSubmit">确认搜索</el-button>
        </el-form-item>
      </el-form>


      <el-table :data="tableData" style="width: 100%;background-color: rgba(242, 242, 242, 1);">
          <el-table-column prop="li1" label="序列"  width="60">
          </el-table-column>
          <el-table-column prop="li2" label="姓名" align="center">
          </el-table-column>
          <el-table-column prop="li3" label="排班日期" align="center">
          </el-table-column>
          <el-table-column prop="li4" label="时间段" align="center">
          </el-table-column>
          <el-table-column prop="li5" label="人数限制" align="center">
          </el-table-column>
          <el-table-column prop="li6" label="取消预约限制" align="center">
          </el-table-column>
          <el-table-column prop="li7" label="状态" align="center">
          </el-table-column>
          <el-table-column prop="li8" label="是否启用" align="center">
          </el-table-column>
          <el-table-column prop="li9" label="创建时间" align="center">
          </el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
              <el-button type="text" size="small">编辑</el-button>
            </template>
          </el-table-column>
      </el-table>
      
    </div>
  </el-col>
</el-row>
    

</template>
<script>
  export default {
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        tableData: [{
            li1: '1',
            li2: '王小虎',
            li3: '2020-10-01',
            li4: '8:00-9:00',
            li5: '1',
            li6: '0',
            li7: '已发布',
            li8: '启用',
            li9: '2020-10-01',
          }, {
            li1: '2',
            li2: '王小虎',
            li3: '2020-10-01',
            li4: '8:00-9:00',
            li5: '1',
            li6: '0',
            li7: '已发布',
            li8: '启用',
            li9: '2020-10-01',
          },
          {
            li1: '3',
            li2: '王小虎',
            li3: '2020-10-01',
            li4: '8:00-9:00',
            li5: '1',
            li6: '0',
            li7: '已发布',
            li8: '启用',
            li9: '2020-10-01',
          },{
            li1: '4',
            li2: '王小虎',
            li3: '2020-10-01',
            li4: '8:00-9:00',
            li5: '1',
            li6: '0',
            li7: '已发布',
            li8: '启用',
            li9: '2020-10-01',
          },{
            li1: '5',
            li2: '王小虎',
            li3: '2020-10-01',
            li4: '8:00-9:00',
            li5: '1',
            li6: '0',
            li7: '已发布',
            li8: '启用',
            li9: '2020-10-01',
          },{
            li1: '6',
            li2: '王小虎',
            li3: '2020-10-01',
            li4: '8:00-9:00',
            li5: '1',
            li6: '0',
            li7: '已发布',
            li8: '启用',
            li9: '2020-10-01',
          }],
        form: {
          name: '',
          region: '',
          date1: '',
        }
      }
    },
    methods: {
      onSubmit() {

      },
      resetForm(form) {
        this.$refs[form].resetFields();
      },
      onSubmit() {
        let {name,region,date1,value2} = this.form;
          this.tableData[{
            li1: '6',
            li2: '王小sss虎',
            li3: '2020-10-01',
            li4: '8:00-9:00',
            li5: '1',
            li6: '0',
            li7: '已发布',
            li8: '启用',
            li9: '2020-10-01',
          }]
        
      }
    }
  }
</script>
<style scoped>
h2{margin-bottom: 20px;font-size: 18px;}
.el-col-11 {width: 38.83333%;}
.el-form-item__content{margin-left: 0px!important;}
/* .grid-content{background-color: blue;} */

</style>